import { apiClient } from '@/services/api/client'

export interface LocalAuthUserOption {
  email: string
  name: string
  role: string
}

export interface LocalAuthUsersResponse {
  default_user: string
  auto_login: boolean
  users: LocalAuthUserOption[]
}

export interface LocalLoginResponse {
  session_token: string
  expires_at: string
  user: {
    uid: string
    email: string
    name: string
    provider: string
  }
}

const LOCAL_AUTH_USERS_CACHE_TTL_MS = 10_000

let localAuthUsersInFlight: Promise<LocalAuthUsersResponse> | null = null
let localAuthUsersCache:
  | { expiresAt: number; value: LocalAuthUsersResponse }
  | null = null

export const localAuthAPI = {
  listUsers(): Promise<LocalAuthUsersResponse> {
    const now = Date.now()
    if (localAuthUsersCache && localAuthUsersCache.expiresAt > now) {
      return Promise.resolve(localAuthUsersCache.value)
    }

    if (localAuthUsersInFlight) {
      return localAuthUsersInFlight
    }

    localAuthUsersInFlight = apiClient
      .get<LocalAuthUsersResponse>('/auth/dev/users')
      .then((response) => {
        localAuthUsersCache = {
          value: response,
          expiresAt: Date.now() + LOCAL_AUTH_USERS_CACHE_TTL_MS,
        }
        return response
      })
      .finally(() => {
        localAuthUsersInFlight = null
      })

    return localAuthUsersInFlight
  },

  login(email?: string): Promise<LocalLoginResponse> {
    localAuthUsersCache = null
    return apiClient.post<LocalLoginResponse>(
      '/auth/dev/login',
      email ? { email } : {},
    )
  },
}
